<template>
  <div
    :class="['dialog-group ', dialogContent.dialogType === 'form' ? 'yl-use dialog-form ' : (dialogContent.dialogType === 'modify' ? 'modify ' : 'dialog-group yl-use')]">
    <el-dialog 
      :class="String(dialogContent.isShowClose) !== 'false' ? '' : 'no-close'" 
      :title="dialogContent.title"
      :visible.sync="dialogContent.visible" 
      @close="cancelBtn" 
      :width="width"
      >
      <div class="bd-content" v-if="dialogContent.content">{{ dialogContent.content }}</div>
      <slot v-else></slot>
      <div v-if="dialogContent.dialogType === 'form'" slot="footer" class="dialog-footer">
        <div class="btn-item btn-left">
          <el-button @click="cancelBtn">{{ dialogContent.leftBtnName }}</el-button>
        </div>
        <div class="btn-item btn-right">
          <el-button type="primary" @click="(e) => (UtilFn.debounce(() => { confirmBtn(e) }, 500)())">{{ dialogContent.rightBtnName }}</el-button>
        </div>
      </div>
      <div v-if="dialogContent.dialogType === 'tips'" slot="footer" class="dialog-footer">
        <div class="btn-item btn-center">
          <el-button type="primary" @click="cancelBtn">{{ dialogContent.tipName }}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    dialogContent: {
      type: Object,
      default: null
    },
    width:{
      type: String,
      default: ()=>{
        return '60%'
      }
    },
    // 是否表单的2个按钮都是触发提交:比如打卡完成条件，仅为当前任务保存、提交并覆盖所有任务
    isTwoBtnSubmit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogFormVisible: false,
      formLabelWidth: '120px'
    }
  },
  created() { },
  destroyed() { },
  mounted() { },
  computed: {},
  watch: {},
  methods: {
    cancelBtn(e) {
      // 当form按钮一个取消一个submit时，走正常逻辑
      if (!this.isTwoBtnSubmit) {
        if (e) {
          this.preventDefault(e)
        }
        this.$emit('left', e)
      } else { // 否则点击按钮的cancel还走表单，但是关闭icon触发的事件仅执行关闭弹窗
        if (e) {
          this.$emit('left', e)
        } else {
          this.$emit('closeIconClick', null)
        }
      }
    },
    confirmBtn(e) {
      if (e) {
        this.preventDefault(e)
      }
      this.$emit('right', e)
    },
    preventDefault (e) {
      // 解决报错：Cannot read properties of undefined (reading 'preventDefault')
      // 没有 event 时直接跳过
      if (!e) return
      e.preventDefault && e.preventDefault()
      e.stopPropagation  && e.stopPropagation()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
.dialog-group {
 ::v-deep .el-dialog__header {
    padding: 0;
    // text-align: left;
    // text-align: center;
    .el-dialog__body{
      padding-top: 20px;
    }
   
    .el-dialog__title {
      font-size: 20px;
      color: #000;
      font-weight: 500;
    }

    .el-dialog__headerbtn {
      top: 10.5px;
      right: 10.5px;
      color: #d8d8d8;
      font-size: 20px;
    }
  }

  .no-close {
    .el-dialog__header {
      .el-dialog__headerbtn {
        display: none;
      }
    }
  }
}

.yl-use {
  .el-dialog {
    border-radius: 8px;
    .el-dialog__body {
      padding: 20px;
      .form-title {
        margin-bottom: 10px;
      }

      .bd-content {
        white-space: pre-line;
      }

      .el-form-item {
        margin-bottom: 24px;

        .el-form-item__content {
          .el-checkbox-group .el-checkbox {
            width: 100%;
            text-align: left;
          }
        }
      }
    }

    .el-dialog__footer {
      padding: 15px 47px;
      border-top: solid 1px #ddd;

      .dialog-footer {
        display: flex;
        justify-content: flex-end;

        // .btn-item {
        //   flex: 1;
        //   text-align: center;
        // }

        .el-button {
          min-width: 60px;
          // padding: 10px 20px;
          margin-left: 10px;
          background-color: #fff;
          border-color: $mainBg;
          color: $mainBg;
        }

        .el-button--primary {
          background-color: $mainBg;
          border-color: $mainBg;
          color: #fff;
        }
      }
    }
  }
}
</style>
